/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_FreeInputs */

const en_plan_free = /** @type {(inputs: Plan_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free Plan`)
};

const es_plan_free = /** @type {(inputs: Plan_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan Gratis`)
};

const fr_plan_free = /** @type {(inputs: Plan_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forfait Gratuit`)
};

const de_plan_free = /** @type {(inputs: Plan_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Plan`)
};

const ja_plan_free = /** @type {(inputs: Plan_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料プラン`)
};

const zh_plan_free = /** @type {(inputs: Plan_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费计划`)
};

const ar_plan_free = /** @type {(inputs: Plan_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الخطة المجانية`)
};

const id_plan_free = /** @type {(inputs: Plan_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paket Gratis`)
};

const it_plan_free = /** @type {(inputs: Plan_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piano Gratuito`)
};

const ru_plan_free = /** @type {(inputs: Plan_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тариф Бесплатный`)
};

const pt_plan_free = /** @type {(inputs: Plan_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plano Grátis`)
};

const ko_plan_free = /** @type {(inputs: Plan_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`무료 요금제`)
};

/**
* | output |
* | --- |
* | "Free Plan" |
*
* @param {Plan_FreeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const plan_free = /** @type {((inputs?: Plan_FreeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_FreeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_plan_free(inputs)
	if (locale === "es") return es_plan_free(inputs)
	if (locale === "fr") return fr_plan_free(inputs)
	if (locale === "de") return de_plan_free(inputs)
	if (locale === "ja") return ja_plan_free(inputs)
	if (locale === "zh") return zh_plan_free(inputs)
	if (locale === "ar") return ar_plan_free(inputs)
	if (locale === "id") return id_plan_free(inputs)
	if (locale === "it") return it_plan_free(inputs)
	if (locale === "ru") return ru_plan_free(inputs)
	if (locale === "pt") return pt_plan_free(inputs)
	return ko_plan_free(inputs)
});